/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CollectionDatePreview } from '../models/CollectionDatePreview';
import type { MonthEnum } from '../models/MonthEnum';
import type { PreviewCollectionDatePayload } from '../models/PreviewCollectionDatePayload';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SchedulesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Preview Collection Dates For Schedule
     * @param dateCount
     * @param fiscalYearEndMonth
     * @param requestBody
     * @returns CollectionDatePreview Successful Response
     * @throws ApiError
     */
    public previewCollectionDatesForSchedule(
        dateCount: (number | null),
        fiscalYearEndMonth: MonthEnum,
        requestBody: PreviewCollectionDatePayload,
    ): CancelablePromise<Array<CollectionDatePreview>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/schedules/preview-collection-dates',
            query: {
                'date_count': dateCount,
                'fiscal_year_end_month': fiscalYearEndMonth,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Generate Start Date Candidates For Schedule
     * @param fiscalYearEndMonth
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    public generateStartDateCandidatesForSchedule(
        fiscalYearEndMonth: MonthEnum,
        requestBody: PreviewCollectionDatePayload,
    ): CancelablePromise<Array<string>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/schedules/generate-start-date-candidates-for-rrule',
            query: {
                'fiscal_year_end_month': fiscalYearEndMonth,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
